// Хранилище черновика
export const VISA_DRAFT_STORAGE_KEY_PREFIX = 'free-avia:visa-draft';

/**
 * `expiresAt` = 30 дней от последнего изменения. Позже станет
 * min(30 дней, дата вылета): после вылета черновик бессмысленен.
 */
export const VISA_DRAFT_TTL_DAYS = 30;

export const buildVisaDraftKey = (
  userId: string,
  countryCode: string,
): string =>
  `${VISA_DRAFT_STORAGE_KEY_PREFIX}:${userId}:${countryCode.toUpperCase()}`;

export const VISA_PROFILE_STORAGE_KEY_PREFIX = 'free-avia:visa-profile';

export const buildVisaProfileKey = (userId: string): string =>
  `${VISA_PROFILE_STORAGE_KEY_PREFIX}:${userId}`;

// Дисклеймер
/**
 * Версия юридического текста пишется в черновик вместе с фактом согласия — по
 * ней видно, под чем человек подписался. Правка текста без смены версии нового
 * согласия не требует, смена версии — требует.
 */
export const VISA_DISCLAIMER_VERSION = '2026-08-03';

export const VISA_DISCLAIMER_POINT_KEYS = [
  'no-guarantee',
  'user-responsibility',
  'no-influence',
  'assistant-only',
  'no-liability',
] as const;

// Онбординг
/**
 * Флаг уровня пользователя, а не страны: онбординг показывается до выбора
 * страны. Пока `localStorage`; с серверным черновиком переедет в user-scoped
 * запись, чтобы не всплывать второй раз на другом устройстве.
 */
export const VISA_ONBOARDING_STORAGE_KEY = 'free-avia:visa-onboarding-seen';

export const VISA_ONBOARDING_SLIDE_KEYS = [
  'whats-needed',
  'bot-helps',
  'self-collect',
  'submit',
] as const;

// Страховка
/**
 * Лендинг оформления полиса: в MVP страховка — переход в Freedom Insurance,
 * покупка внутри чата отложена (решение 29.07 №3).
 *
 * TODO(AVIATA-3669): подтвердить лендинг у продукта до включения VISA_HELP (у
 * бота та же настройка — OFFER_INSURANCE_URL).
 */
export const VISA_INSURANCE_OFFER_URL = 'https://ffins.kz/';

/**
 * Цена в карточке страховки (дизайн 76:6380). Зашита: тарифного эндпоинта в
 * контракте нет, полис оформляется уходом в Freedom Insurance.
 *
 * TODO(AVIATA-3669): подтвердить сумму у продукта вместе с лендингом и заменить
 * на цену из ответа страховщика, когда появится эндпоинт.
 */
export const VISA_INSURANCE_CARD_PRICE = { amount: 4900, currency: '₸' };

// Фикстура броней
/**
 * Обход источника броней: `1` подменяет `/accounts/hotels-orders` фикстурой
 * (стенд отелей стопорит шаг «Проживание»), `0` или пусто — реальный API.
 */
export const VISA_HOTELS_FIXTURE_STORAGE_KEY = 'free-avia:visa-hotels-fixture';

// Флаги входа
/** Локаль квитанции: пакет читает консульство, а не пользователь. */
export const VISA_PACKAGE_RECEIPT_LOCALE = 'en';

/**
 * DEV-обход release-флага раздела (по образцу ai-chat): показывает точки входа,
 * не дожидаясь бакета в эксперименте.
 */
export const VISA_FORCE_OPEN_STORAGE_KEY = 'free-avia:visa-force-open';

// Шторки (FreeBottomSheet)
export const VISA_FORM_BOTTOM_SHEET_NAME = 'visa-form-bottom-sheet';

export const VISA_DISCLAIMER_BOTTOM_SHEET_NAME = 'visa-disclaimer-bottom-sheet';

export const VISA_ONBOARDING_BOTTOM_SHEET_NAME = 'visa-onboarding-bottom-sheet';

/** Шторка шага варианта без чата — своё имя на каждый блок чек-листа. */
export const buildVisaStepSheetName = (step: string): string =>
  `visa-step-bottom-sheet-${step}`;

// visa-bot
/**
 * Префикс роутов визового бота (`visa-bot/src/server.py`): `/visa/sessions`,
 * `/visa/sessions/{sid}` (+`/messages`, `/form`, `/fields`, `/documents`),
 * `/files/{name}`. Бот за тем же Kong, что и остальной трафик, отдельным
 * префиксом — своей базы у фичи нет, запросы идут PFM-клиентом относительным
 * путём. Сессия при создании привязывается к `user.id` из JWT: чужой sid
 * отвечает 403.
 *
 * Авторизация — платформенный JWT: его проверяет jwt+acl на роуте Kong, а
 * SERVICE_TOKEN бота в кластере намеренно не задан. Заголовки и повтор по 401 с
 * рефрешем дают интерсепторы PFM. Роут `/files` живёт без jwt — PDF качается
 * прямым `fetch` по ссылке из реестра.
 */
export const VISA_BOT_BASE_PATH = '/visa-bot';

export { VISA_COUNTRIES } from './countries';
